/**
 * Fold one dismissal into the cached dismissals list, replacing any earlier
 * record for the same key. Both clients write this into the query cache
 * before the PUT resolves, so a surface keyed on `dismissed` cannot flash
 * back open while the request is in flight.
 */
export function mergeExplainerDismissal(current, dismissal) {
    const dismissals = [
        dismissal,
        ...(current?.dismissals.filter((item) => item.key !== dismissal.key) ?? []),
    ];
    return {
        dismissals,
        dismissedKeys: dismissals.map((item) => item.key),
    };
}
//# sourceMappingURL=explainer-dismissals.js.map